module.exports = __webpack_public_path__ + "img/sm-oval-2.115bee71.png";